import { query, queryAll } from '../core/dom.js';

const SELECTORS = {
  root: '[data-color-variations]',
  option: '[data-color-option]',
  label: '[data-color-variation-selected]',
};

const ESTAMPAS_SLIDER_SELECTOR = '[data-estampas-slider]';

const clampIndex = (value, min, max) => Math.min(Math.max(value, min), max);

const setActiveOption = (options, active, labelEl, updateLabel = true) => {
  const activeLabel = active?.dataset?.variationLabel?.trim() ?? '';

  options.forEach((option) => {
    const isActive = option === active;
    option.classList.toggle('is-active', isActive);
    option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  });

  if (updateLabel && labelEl && activeLabel) {
    labelEl.textContent = activeLabel;
  }
};

const dispatchEstampaSlideChange = (slider, option) => {
  if (!slider || !option) {
    return;
  }

  const rawIndex = option.dataset?.estampaSlideIndex;
  if (typeof rawIndex === 'undefined' || rawIndex === '') {
    return;
  }

  const parsedIndex = Number(rawIndex);
  if (Number.isNaN(parsedIndex)) {
    return;
  }

  slider.dispatchEvent(
    new CustomEvent('estampa:slide-select', {
      detail: { index: parsedIndex },
      bubbles: true,
    }),
  );
};

const setupRoot = (root) => {
  const options = queryAll(SELECTORS.option, root);
  const labelEl = query(SELECTORS.label, root);
  const slider = root.ownerDocument?.querySelector(ESTAMPAS_SLIDER_SELECTOR) ?? null;

  const syncFromSlider = (event) => {
    const { detail } = event || {};
    if (!detail || typeof detail.index !== 'number') {
      return;
    }

    const targetOption = options.find((option) => {
      const rawIndex = option.dataset?.estampaSlideIndex;
      return rawIndex !== undefined && Number(rawIndex) === detail.index;
    });

    if (targetOption) {
      setActiveOption(options, targetOption, labelEl);
    }
  };

  slider?.addEventListener('estampa:slide-active', syncFromSlider);

  if (!options.length) {
    return;
  }

  const activateOption = (option, updateLabel = true) => {
    setActiveOption(options, option, labelEl, updateLabel);
    dispatchEstampaSlideChange(slider, option);
  };

  const initial = options.find((option) => option.classList.contains('is-active')) ?? options[0];
  activateOption(initial, false);

  options.forEach((option, index) => {
    option.addEventListener('click', () => activateOption(option));
    option.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        activateOption(option);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        const nextIndex = clampIndex(index + 1, 0, options.length - 1);
        activateOption(options[nextIndex]);
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        const prevIndex = clampIndex(index - 1, 0, options.length - 1);
        activateOption(options[prevIndex]);
      }
    });
  });
};

export function initColorVariations() {
  const roots = queryAll(SELECTORS.root);

  if (!roots.length) {
    return;
  }

  roots.forEach(setupRoot);
}
